import moment from "moment";
import { comparses } from "../../data/comparses";

export const ResultatsColumns = () => {
	const columns = [
		{
			name: "nom_nen",
			label: "Nom infant",
			options: {
				filter: false,
				sort: true,
				sortOrder: "desc",
			},
		},
		{
			name: "cognoms_nen",
			label: "Cognoms infant",
			options: {
				filter: false,
				sort: true,
				sortOrder: "desc",
			},
		},
		{
			name: "dni_nen",
			label: "DNI o targeta sanitària infant",
			options: {
				filter: false,
				sort: true,
				sortOrder: "desc",
			},
		},

		{
			name: "data_n_nen",
			label: "Data naixement infant",
			options: {
				filter: false,
				sort: true,
				sortOrder: "desc",
				customBodyRender: (value) => moment(value).format("DD/MM/YYYY"),
			},
		},
		{
			name: "anys",
			label: "Edat infant",
			options: {
				filter: false,
				sort: true,
				sortOrder: "desc",
				customBodyRender: (value) => value + " anys",
			},
		},
		{
			name: "nom",
			label: "Nom pare/mare/tutor",
			options: {
				filter: false,
				sort: true,
				sortOrder: "desc",
			},
		},
		{
			name: "cognoms",
			label: "Cognom pare/mare/tutor",
			options: {
				filter: false,
				sort: true,
				sortOrder: "desc",
			},
		},
		{
			name: "email",
			label: "E-mail",
			options: {
				filter: false,
				sort: true,
				sortOrder: "desc",
			},
		},
		{
			name: "telefon",
			label: "Telèfon",
			options: {
				filter: false,
				sort: true,
				sortOrder: "desc",
			},
		},
		{
			name: "dni",
			label: "DNI",
			options: {
				filter: false,
				sort: true,
				sortOrder: "desc",
			},
		},
		{
			name: "data_n",
			label: "Data naixement",
			options: {
				filter: false,
				sort: true,
				sortOrder: "desc",
				customBodyRender: (value) => moment(value).format("DD/MM/YYYY"),
			},
		},
		{
			name: "comparsa",
			label: "Comparsa final",
			options: {
				filter: true,
				sort: true,
				sortOrder: "desc",
			},
		},
		{
			name: "suplent",
			label: "Suplent",
			options: {
				filter: true,
				sort: true,
				sortOrder: "desc",
			},
		},
		{
			name: "alcada",
			label: "Alçada infant",
			options: {
				filter: false,
				sort: true,
				sortOrder: "desc",
				customBodyRender: (value) => value && value + " cm",
			},
		},
		{
			name: "nom_acompanyant",
			label: "Nom infant",
			options: {
				filter: false,
				sort: true,
				sortOrder: "desc",
			},
		},
		{
			name: "cognoms_acompanyant",
			label: "Cognoms infant",
			options: {
				filter: false,
				sort: true,
				sortOrder: "desc",
			},
		},
		{
			name: "dni_acompanyant",
			label: "DNI infant",
			options: {
				filter: false,
				sort: true,
				sortOrder: "desc",
			},
		},

		{
			name: "data_n_acompanyant",
			label: "Data naixement acompanyant",
			options: {
				filter: false,
				sort: true,
				sortOrder: "desc",
				customBodyRender: (value) => value && moment(value).format("DD/MM/YYYY"),
			},
		},
	];
	return columns;
};
